import React from "react";
import { useLang } from "../contexts/LanguageContext";

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#1A201C] text-[#FDFBF7] pt-20 pb-8 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-12 gap-10 md:gap-12 pb-16 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="mb-6">
              <img
                src="/ekobiotek-logo-white.webp"
                alt="EKOBIOTEK Ukraine"
                className="h-20 w-auto object-contain"
                loading="lazy"
              />
            </div>
            <p className="text-sm text-white/65 max-w-md leading-relaxed">{t.footer.tagline}</p>
            <div className="overline text-white/40 mt-6">{t.footer.edrpou}</div>
          </div>

          <div className="md:col-span-3">
            <div className="overline text-white/40 mb-5">{t.nav.contact}</div>
            <ul className="space-y-3 text-sm text-white/80">
              <li>73000, Kherson</li>
              <li>vul. Raketna, 110a, Ukraine</li>
              <li>
                <a href="mailto:sekretar@ekobiotek-ukrainellc.com" className="hover:text-[#DE9E36]">
                  sekretar@ekobiotek-ukrainellc.com
                </a>
              </li>
              <li>
                <a href="mailto:sekretar@ekobiotek-ukraine.com.ua" className="hover:text-[#DE9E36]">
                  sekretar@ekobiotek-ukraine.com.ua
                </a>
              </li>
              <li>
                <a href="mailto:export@ekobiotek-ukrainellc.com" className="hover:text-[#DE9E36]">
                  export@ekobiotek-ukrainellc.com
                </a>
              </li>
              <li>
                <span className="text-white/40">Secretariat — Iryna Boyko:</span>{" "}
                <a href="tel:+380939116649" className="whitespace-nowrap hover:text-[#DE9E36]">
                  +380 93 911 6649
                </a>
              </li>
              <li>
                <span className="text-white/40">Export — Tatiana Chaban:</span>{" "}
                <a href="tel:+380933681038" className="whitespace-nowrap hover:text-[#DE9E36]">
                  +380 93 368 1038
                </a>
              </li>
              <li>
                <span className="text-white/40">Logistic — Alexandre Katcho:</span>{" "}
                <a href="tel:+380947121387" className="whitespace-nowrap hover:text-[#DE9E36]">
                  +380 94 712 1387
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline text-white/40 mb-5">{t.nav.about}</div>
            <ul className="grid grid-cols-2 gap-3 text-sm text-white/80">
              <li>
                <a href="#about" className="hover:text-[#DE9E36]">
                  {t.nav.about}
                </a>
              </li>
              <li>
                <a href="#products" className="hover:text-[#DE9E36]">
                  {t.nav.products}
                </a>
              </li>
              <li>
                <a href="#process" className="hover:text-[#DE9E36]">
                  {t.nav.process}
                </a>
              </li>
              <li>
                <a href="#quality" className="hover:text-[#DE9E36]">
                  {t.nav.quality}
                </a>
              </li>
              <li>
                <a href="#export" className="hover:text-[#DE9E36]">
                  {t.nav.export}
                </a>
              </li>
              <li>
                <a href="#contact" className="hover:text-[#DE9E36]">
                  {t.nav.contact}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Massive logo */}
        <div className="py-12 select-none overflow-hidden">
          <div
            className="font-bold leading-none whitespace-nowrap tracking-[-0.04em] text-[18vw] md:text-[14vw] shine-text"
          >
            EKOBIOTEK
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-6 border-t border-white/10">
          <div className="text-xs text-white/45">
            © {year} EKOBIOTEK-UKRAINA, LLC. {t.footer.rights}
          </div>
          <div className="flex items-center gap-6 text-xs text-white/45">
            <a href="#contact" className="hover:text-[#DE9E36]">
              {t.footer.legal}
            </a>
            <span>Kherson · Ukraine</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
